import { render, staticRenderFns } from "./administradores.vue?vue&type=template&id=c98e1588&scoped=true"
import script from "./administradores.vue?vue&type=script&lang=js"
export * from "./administradores.vue?vue&type=script&lang=js"
import style0 from "./administradores.vue?vue&type=style&index=0&id=c98e1588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98e1588",
  null
  
)

export default component.exports